module.exports = __webpack_public_path__ + "static/media/bubble1.946b8ae0.svg";